import SpeedDating from './container';

export default SpeedDating;



// WEBPACK FOOTER //
// ./src/routes/SpeedDating/index.js